export default "__VITE_ASSET__d926f86e__"